const userRoles = [
	{ value: "Admin", label: "Admin" },
	{ value: "Seller", label: "Seller" },
	{ value: "Finance", label: "Finance" },
	{ value: "Batch", label: "Batch" },
	{ value: "Manager", label: "Manager" },
	{ value: "Mechanic", label: "Mechanic" },
];

export { userRoles };
